import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import useContent from "@lib/use_content";
import Button from "@hudson/ui/components/FormFields/Button";
import Login from "./Login";

interface LoginOrCreateProps {
  defaultEmail?: string;
  hideCreate?: boolean;
  onLogin?: () => void;
  onPageChange: (page: string) => void;
}

function LoginOrCreate({ defaultEmail, hideCreate, onLogin, onPageChange }: LoginOrCreateProps) {
  const { data, loading } = useContent([
    "beCreateNewAccountTitle",
    "beForgotPwButton",
    "beLoginTitle",
    "beCreateNewAccountButton",
    "beLoginSubmitButton",
    "bePasswordLabel",
    "beUsernameLabel",
  ]);

  function onSuccessfulLogin() {
    if (onLogin) onLogin();
    else window.location.reload();
  }

  return (
    <>
      {loading ? (
        <ConcentricLoader className="opacity-60 max-w-2xl mx-auto  px-4 sm:py-10 sm:px-6 lg:px-8" />
      ) : (
        <>
          <Login
            defaultEmail={defaultEmail}
            onGotoSendResetPage={() => onPageChange("sendReset")}
            onSuccessfulLogin={onSuccessfulLogin}
          />

          {!hideCreate && (
            <div
              className="py-10 sm:py-10  -ml-10 -mr-10 mt-0  -mb-8 shadow-inner"
              style={{
                backgroundColor: "var(--primary-color)",
              }}
            >
              <div className="flex flex-col items-center  sm:gap-x-4 mx-auto max-w-xs gap-y-4">
                <h2
                  className="mb-3 text-3xl md:text-3xl font-extrabold flex items-center flex-wrap opacity-70"
                  style={{
                    color: "var(--primary-text)",
                  }}
                >
                  {data?.content.beCreateNewAccountTitle}
                </h2>
                <Button
                  className="text-lg"
                  asLink
                  color="primaryText"
                  onClick={() => onPageChange("newUser")}
                  style={{ textDecoration: "underline" }}
                  type="button"
                >
                  {data?.content.beCreateNewAccountButton}
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default LoginOrCreate;
